/* Rippin Moto: Blackline family strip. Each card carries one photo per wheel
   color and a row of swatches. On load every card shows a random color, and
   a swatch click or hover switches the photo. Without JavaScript the first
   color stays visible. */
(function () {
  'use strict';

  function show(card, color) {
    var imgs = card.querySelectorAll('.rm-line-card__img[data-rm-color]');
    var dots = card.querySelectorAll('.rm-line-card__swatch');
    var found = false;
    imgs.forEach(function (img) {
      var on = img.getAttribute('data-rm-color') === color;
      img.hidden = !on;
      if (on) found = true;
    });
    if (!found && imgs.length) imgs[0].hidden = false;
    dots.forEach(function (dot) {
      dot.setAttribute('aria-pressed', dot.getAttribute('data-rm-color') === color ? 'true' : 'false');
    });
  }

  function init(card) {
    var dots = card.querySelectorAll('.rm-line-card__swatch');
    if (dots.length < 2) return;
    var pick = dots[Math.floor(Math.random() * dots.length)];
    show(card, pick.getAttribute('data-rm-color'));
    dots.forEach(function (dot) {
      var color = dot.getAttribute('data-rm-color');
      dot.addEventListener('click', function () { show(card, color); });
      dot.addEventListener('mouseenter', function () { show(card, color); });
      dot.addEventListener('focus', function () { show(card, color); });
    });
  }

  document.querySelectorAll('[data-rm-family-card]').forEach(init);
})();
